var map = {
	"./AD.svg": 4741,
	"./AE.svg": 3108,
	"./AF.svg": 1319,
	"./AG.svg": 4454,
	"./AI.svg": 752,
	"./AL.svg": 765,
	"./AM.svg": 2220,
	"./AO.svg": 4494,
	"./AQ.svg": 4248,
	"./AR.svg": 2315,
	"./AS.svg": 4794,
	"./AT.svg": 1973,
	"./AU.svg": 4724,
	"./AW.svg": 198,
	"./AX.svg": 1377,
	"./AZ.svg": 8003,
	"./BA.svg": 5073,
	"./BB.svg": 8354,
	"./BD.svg": 5980,
	"./BE.svg": 8573,
	"./BF.svg": 6574,
	"./BG.svg": 8655,
	"./BH.svg": 2120,
	"./BI.svg": 9,
	"./BJ.svg": 1898,
	"./BL.svg": 8180,
	"./BM.svg": 9349,
	"./BN.svg": 6918,
	"./BO.svg": 4951,
	"./BQ.svg": 3041,
	"./BR.svg": 3554,
	"./BS.svg": 4547,
	"./BT.svg": 4364,
	"./BV.svg": 9662,
	"./BW.svg": 7039,
	"./BY.svg": 2185,
	"./BZ.svg": 810,
	"./CA.svg": 1138,
	"./CC.svg": 5088,
	"./CD.svg": 4623,
	"./CF.svg": 5069,
	"./CG.svg": 5596,
	"./CH.svg": 8763,
	"./CI.svg": 8394,
	"./CK.svg": 4376,
	"./CL.svg": 7207,
	"./CM.svg": 3382,
	"./CN.svg": 1605,
	"./CO.svg": 8996,
	"./CR.svg": 6305,
	"./CU.svg": 4158,
	"./CV.svg": 6157,
	"./CW.svg": 3564,
	"./CX.svg": 4091,
	"./CY.svg": 9482,
	"./CZ.svg": 7593,
	"./DE.svg": 4447,
	"./DJ.svg": 6296,
	"./DK.svg": 1689,
	"./DM.svg": 7543,
	"./DO.svg": 965,
	"./DS.svg": 8225,
	"./DZ.svg": 5419,
	"./EC.svg": 6910,
	"./EE.svg": 9456,
	"./EG.svg": 8690,
	"./EH.svg": 9685,
	"./ER.svg": 7375,
	"./ES.svg": 9998,
	"./ET.svg": 3377,
	"./FI.svg": 6829,
	"./FJ.svg": 7710,
	"./FK.svg": 8815,
	"./FM.svg": 3057,
	"./FO.svg": 1155,
	"./FR.svg": 758,
	"./GA.svg": 8342,
	"./GB.svg": 9589,
	"./GD.svg": 7019,
	"./GE.svg": 2826,
	"./GF.svg": 3577,
	"./GG.svg": 5656,
	"./GH.svg": 8431,
	"./GI.svg": 5854,
	"./GL.svg": 4035,
	"./GM.svg": 6098,
	"./GN.svg": 1137,
	"./GP.svg": 3319,
	"./GQ.svg": 5782,
	"./GR.svg": 4917,
	"./GS.svg": 196,
	"./GT.svg": 2347,
	"./GU.svg": 3290,
	"./GW.svg": 3512,
	"./GY.svg": 5294,
	"./HK.svg": 1101,
	"./HM.svg": 483,
	"./HN.svg": 1088,
	"./HR.svg": 5060,
	"./HT.svg": 5130,
	"./HU.svg": 2651,
	"./ID.svg": 2781,
	"./IE.svg": 8508,
	"./IL.svg": 2341,
	"./IM.svg": 356,
	"./IN.svg": 8215,
	"./IO.svg": 1094,
	"./IQ.svg": 592,
	"./IR.svg": 1491,
	"./IS.svg": 2498,
	"./IT.svg": 7165,
	"./JE.svg": 1941,
	"./JM.svg": 5405,
	"./JO.svg": 4959,
	"./JP.svg": 40,
	"./KE.svg": 2950,
	"./KG.svg": 7476,
	"./KH.svg": 755,
	"./KI.svg": 7026,
	"./KM.svg": 2574,
	"./KN.svg": 5549,
	"./KP.svg": 7211,
	"./KR.svg": 4041,
	"./KW.svg": 5860,
	"./KY.svg": 9586,
	"./KZ.svg": 4625,
	"./LA.svg": 7179,
	"./LB.svg": 2792,
	"./LC.svg": 681,
	"./LI.svg": 547,
	"./LK.svg": 5745,
	"./LR.svg": 7464,
	"./LS.svg": 2857,
	"./LT.svg": 6470,
	"./LU.svg": 295,
	"./LV.svg": 2084,
	"./LY.svg": 5219,
	"./MA.svg": 9668,
	"./MC.svg": 4054,
	"./MD.svg": 441,
	"./ME.svg": 5048,
	"./MF.svg": 9435,
	"./MG.svg": 9066,
	"./MH.svg": 5741,
	"./MK.svg": 7918,
	"./ML.svg": 1297,
	"./MM.svg": 5760,
	"./MN.svg": 6451,
	"./MO.svg": 1810,
	"./MP.svg": 7605,
	"./MQ.svg": 6436,
	"./MR.svg": 3207,
	"./MS.svg": 5174,
	"./MT.svg": 8265,
	"./MU.svg": 376,
	"./MV.svg": 4763,
	"./MW.svg": 154,
	"./MX.svg": 9210,
	"./MY.svg": 4236,
	"./MZ.svg": 6911,
	"./NA.svg": 6221,
	"./NC.svg": 3439,
	"./NE.svg": 977,
	"./NF.svg": 6930,
	"./NG.svg": 3536,
	"./NI.svg": 9045,
	"./NL.svg": 552,
	"./NO.svg": 5739,
	"./NP.svg": 8172,
	"./NR.svg": 4622,
	"./NU.svg": 8177,
	"./NZ.svg": 8377,
	"./OM.svg": 6026,
	"./PA.svg": 1519,
	"./PE.svg": 7123,
	"./PF.svg": 1984,
	"./PG.svg": 4225,
	"./PH.svg": 1430,
	"./PK.svg": 2677,
	"./PL.svg": 2266,
	"./PM.svg": 107,
	"./PN.svg": 8744,
	"./PR.svg": 7788,
	"./PS.svg": 7501,
	"./PT.svg": 2834,
	"./PW.svg": 3729,
	"./PY.svg": 6407,
	"./QA.svg": 888,
	"./RE.svg": 3853,
	"./RO.svg": 4407,
	"./RS.svg": 1091,
	"./RU.svg": 5885,
	"./RW.svg": 7551,
	"./SA.svg": 5250,
	"./SB.svg": 6145,
	"./SC.svg": 3344,
	"./SD.svg": 1903,
	"./SE.svg": 798,
	"./SG.svg": 204,
	"./SH.svg": 7851,
	"./SI.svg": 8794,
	"./SJ.svg": 3881,
	"./SK.svg": 9016,
	"./SL.svg": 8823,
	"./SM.svg": 1286,
	"./SN.svg": 421,
	"./SO.svg": 5700,
	"./SR.svg": 6641,
	"./SS.svg": 4400,
	"./ST.svg": 3935,
	"./SV.svg": 5533,
	"./SX.svg": 2523,
	"./SY.svg": 4682,
	"./SZ.svg": 9081,
	"./TC.svg": 7217,
	"./TD.svg": 5662,
	"./TF.svg": 1276,
	"./TG.svg": 8637,
	"./TH.svg": 634,
	"./TJ.svg": 88,
	"./TK.svg": 5449,
	"./TL.svg": 6038,
	"./TM.svg": 5015,
	"./TN.svg": 564,
	"./TO.svg": 7813,
	"./TR.svg": 6592,
	"./TT.svg": 334,
	"./TV.svg": 4412,
	"./TW.svg": 6605,
	"./TZ.svg": 4760,
	"./UA.svg": 1996,
	"./UG.svg": 258,
	"./UM.svg": 2344,
	"./UNDEF.svg": 9192,
	"./US.svg": 3246,
	"./UY.svg": 8148,
	"./UZ.svg": 2599,
	"./VA.svg": 1637,
	"./VC.svg": 596,
	"./VE.svg": 2361,
	"./VG.svg": 8331,
	"./VI.svg": 4637,
	"./VN.svg": 706,
	"./VU.svg": 3977,
	"./WF.svg": 1017,
	"./WS.svg": 2420,
	"./XK.svg": 6893,
	"./YE.svg": 9740,
	"./YT.svg": 1245,
	"./ZA.svg": 4217,
	"./ZM.svg": 253,
	"./ZW.svg": 1303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5870;